/**
 * Reglas compartidas de usuarios de la comanda (multi-mozo, RES-113).
 *
 * Los roles que pueden operar la comanda (y por eso necesitan un local asignado y un PIN
 * propio) son los mismos que valida el backend en `PUT /organizations/{org}/users/{uid}/pin`.
 */

// Roles con local asignado y PIN de comanda. OWNER tiene acceso a todos los locales y no usa PIN.
export const COMANDA_PIN_ROLES = ['ADMIN', 'COMANDA', 'BARRA', 'STAFF'];

// PIN personal: de 4 a 6 dígitos, mismo formato que valida el servidor.
export const COMANDA_PIN_PATTERN = /^\d{4,6}$/;

/** El rol viene en minúsculas desde ORG#/USER# y en mayúsculas desde Cognito: se normaliza. */
export const normalizeRole = (role) => String(role || '').toUpperCase();

export const roleUsesPin = (role) => COMANDA_PIN_ROLES.includes(normalizeRole(role));

export const isValidComandaPin = (pin) => COMANDA_PIN_PATTERN.test(String(pin || ''));

/**
 * Valida el par PIN + confirmación del formulario.
 * @returns {'invalid' | 'mismatch' | null} código de error (clave i18n `users.pin.<código>`), o null
 */
export const validatePinPair = (pin, confirmPin) => {
  if (!isValidComandaPin(pin)) return 'invalid';
  if (pin !== confirmPin) return 'mismatch';
  return null;
};

/** Deja solo dígitos y corta a 6: el input numérico no deja pasar letras ni espacios. */
export const sanitizePinInput = (value) =>
  String(value || '')
    .replace(/\D/g, '')
    .slice(0, 6);
